<template>
  <div class="container-fluid">
    <!--  -->
    <div class="row">
      <div class="col-md-12 col-xl-12 mb-4">
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <b-card class="card-shape home-box">
              <b-skeleton width="85%" height="20%"></b-skeleton>
              <b-skeleton width="70%" height="20%"></b-skeleton>
              <b-skeleton width="70%" height="20%"></b-skeleton>
            </b-card>
          </template>

          <div class="card border-start-primary py-2 card-shape home-box">
            <div class="card-body">
              <div class="row align-items-center no-gutters">

                <!-- Headers -->
                <div class="col-1">
                  <h4 class="fs-6 fw-bold">PERIOD</h4>
                </div>
                <div class="col-6">
                  <h4 class="fs-6 fw-bold akkurate-green">DEPOSIT / RECEIPT</h4>
                </div>
                <div class="col-3">
                  <h4 class="fs-6 fw-bold akkurate-danger">WITHDRAWAL / PAYMENT</h4>
                </div>
                <div class="col-2">
                  <h4 class="fs-6 fw-bold akkurate-gray">BALANCE</h4>
                </div>
                <!-- End Headers -->

                <!-- Summary Rows -->
                <div v-for="p_data in paymentsData" :key="p_data.key" class="col-12 row">
                  <!-- Label -->
                  <div class="col-1">
                    <span class="text-uppercase text-xs mb-1">{{ p_data.label }}</span>
                  </div>

                  <!-- Data Columns -->
                  <!-- Deposit -->
                  <div class="col-6">
                    <div class="row">
                      <div class="col-3 text-xs">
                        <span>{{ p_data.depositCount || 0 }}</span>
                      </div>
                      <div class="col-3 text-xs ps-4">
                        <span>{{ displayNumber(p_data.depositAmount) }}</span>
                      </div>
                      <div v-if="p_data.showChange" class="col-4 text-xs ps-4">
                        <span :class="percentageClass(p_data.percentageChange.value)">
                          {{ p_data.percentageChange.strvalue }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- Withdrawal -->
                  <div class="col-3">
                    <div class="row">
                      <div class="col-6 text-xs ps-4">
                        <span>{{ p_data.withdrawalCount || 0 }}</span>
                      </div>
                      <div class="col-6 text-xs ps-4">
                        <span>{{ displayNumber(p_data.withdrawalAmount) }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- Balance -->
                  <div class="col-2 text-xs ps-5">
                    <span>{{ displayNumber(p_data.balance) }}</span>
                  </div>
                </div>
                <!-- End Summary Rows -->
              </div>
            </div>
          </div>
        </b-skeleton-wrapper>
      </div>
      <!-- LOANS -->
      <div class="col-md-12 col-xl-12 mb-12 mb-4">
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <b-card class="card-shape home-box">
              <b-skeleton width="85%" height="20%"></b-skeleton>
              <b-skeleton width="70%" height="20%"></b-skeleton>
              <b-skeleton width="70%" height="20%"></b-skeleton>
            </b-card>
          </template>

          <div class="card border-start-primary py-2 card-shape home-box">
            <div class="card-body">

              <!-- Header -->
              <div class="row text-sm fw-bold mb-2">
                <div class="col-1 text-start">LOANS</div>
                <div class="col-3 akkurate-green">REPAYMENT / RECEIPT</div>
                <div class="col-3 p-0 m-0 text-uppercase fw-bold text-sm mb-1 row text-center">
                  <div class='col-4 p-0 m-0  border-end border-black'> 
                    P
                  </div>
                  <div class='col-4 p-0 m-0  border-end border-black border-start'> 
                    I
                  </div>
                  <div class='col-4 p-0 m-0 akkurate-green border-black border-start'>
                    &nbsp;&nbsp; %
                  </div>

                  <!-- <div class="">P | I </div>
                  <div class="ms-2 akkurate-green fw-bold">
                    &nbsp;&nbsp; %
                  </div> -->
                </div>
                <div class="col-3 text-danger">DISBURSEMENT / PAYMENT</div>
                <div class="col-2">VARIANCE</div>
              </div>

              <!-- Data Rows -->
              <div v-for="(item, idx) in loanData" :key="idx" class="row text-xs align-items-center mb-2">
                <!-- Loans -->
                <div class="col-1 text-uppercase text-start">
                  {{ item.period }}
                </div>

                <!-- Repayment -->
                <div class="col-3">
                  <div class="row">
                    <div class="col-6">{{ item.repayment.count }}</div>
                    <div class="col-6">{{ displayNumber(item.principalInterest.p + item.principalInterest.i) }}</div>
                  </div>
                </div>

                <!-- Principal | Interest + Percent -->
                <div class="col-3 p-0 m-0 row text-center">
                  <div class='col-4 p-0 m-0  border-end border-black'> 
                    {{ displayNumber(item.principalInterest.p) }}
                  </div>
                  <div class='col-4 p-0 m-0  border-end border-black'> 
                    {{ displayNumber(item.principalInterest.i) }}
                  </div>
                  <div class='col-4 p-0 m-0 akkurate-green ' :class="percentageClass(item.principalInterest.percentage.value)" v-if="item.showChange">
                    {{ item.principalInterest.percentage.strvalue }}
                  </div>
                  <!-- <div>
                    <span class="me-2">{{ displayNumber(item.principalInterest.p) }}</span> | <span class="ms-2">{{
                      displayNumber(item.principalInterest.i) }}</span>
                  </div>
                  <div class="ms-3 fw-bold" :class="percentageClass(item.principalInterest.percentage.value)" v-if="item.showChange">
                    {{ item.principalInterest.percentage.strvalue }}
                  </div> -->
                </div>

                <!-- Disbursement -->
                <div class="col-3">
                  <div class="row">
                    <div class="col-6">{{ item.disbursement.count }}</div>
                    <div class="col-6">{{ displayNumber(item.disbursement.amount) }}</div>
                  </div>
                </div>

                <!-- Variance -->
                <div class="col-2">
                  <div>
                    {{ displayNumber(variance(item.repayment.amount, item.disbursement.amount)) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-skeleton-wrapper>
      </div>

      <!-- FIXED DEPOSITE -->
      <div class="col-md-12 col-xl-12 mb-12 mb-4">
        <b-skeleton-wrapper :loading="loading || loadingFd">
          <template #loading>
            <b-card class="card-shape home-box">
              <b-skeleton width="85%" height="20%"></b-skeleton>
              <b-skeleton width="70%" height="20%"></b-skeleton>
              <b-skeleton width="70%" height="20%"></b-skeleton>
            </b-card>
          </template>

          <div class="card border-start-primary py-2 card-shape home-box">
            <div class="card-body col">

              <!-- Header -->
              <div class="row col-12 text-sm align-items-center fw-bold m-0 mb-2">
                <div class="col-4 row text-start">
                  <div class="col-7 p-0  text-uppercase">FIXED TERM DEPOSIT</div>
                  <div class="col-5 p-0 text-uppercase fw-bold text-sm mb-1 akkurate-green">
                  {{ fdFilterValue?.name || '' }}
                  </div>
                </div>
                <div class="col-5 row">
                  <div class="col-3">COUNT</div>
                  <div class="col-5">Principal</div>
                  <div class="col-4">Interest</div>
                </div>
                <div class="col-3 justify-content-between d-flex ">
                    <div>VALUE</div>

                    <div class="dropdown no-arrow d-inline custom-pointer">
                        <a title="Filter" class="btn btn-sm akkurate-gray-btn text-white dropdown-toggle " id="dropdownMenu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <span class="akkurate-small"> <font-awesome-icon :icon="['fas', 'filter']" /></span>
                        </a>

                        <div class="dropdown-menu">
                          <a @click="Filter({name: 'All'})" :title="'None'" class=" dropdown-item border-0 px-1 akkurate-gray">
                             NONE
                          </a>

                          <div class="dropdown-divider my-1"></div>

                          <span v-for="data in fdScheme">
                            <a @click="Filter(data)" :title="data.name" class=" dropdown-item border-0 px-1">
                              {{ data.name }}
                            </a>

                            <!-- <div class="dropdown-divider my-1"></div> -->
                          </span>
                        </div>
                  </div>
                </div>

              </div>

              <!-- Data Rows -->
              <div v-for="(item, idx) in fixedTermDepositData.data" :key="idx" class="row col-12 text-xs align-items-center mb-2">
                <!-- Loans -->
                <div class="col-4 text-uppercase text-start">
                  {{ item.label }}
                </div>

                <!-- COUNT -->
                <div class="col-5 row">
                  <div class="col-3 p-0">
                    {{ item.count || 0 }}
                  </div>
                  <div class="col-5 p-0">
                    {{ item.principal || 0 }}
                  </div>
                  <div class="col-4 p-0">
                    {{ item.interest || 0 }}
                  </div>
                </div>

                <!-- VALUE -->
                <div class="col-3 p-0">
                  {{ displayNumber(item.value) }}
                </div>

              </div>
            </div>
          </div>
        </b-skeleton-wrapper>
      </div>

      <!-- CUSTOMER GROWT -->
      <div class="col-md-6 col-xl-6 mb-4">
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <b-card class="card-shape home-box">
              <b-skeleton width="85%" height="20%"></b-skeleton>
              <b-skeleton width="70%" height="20%"></b-skeleton>
              <b-skeleton width="70%" height="20%"></b-skeleton>
            </b-card>
          </template>

          <div class="card border-start-primary py-2 card-shape home-box">
            <div class="card-body">
              <div class="row align-items-center no-gutters">
                <!-- Title -->
                <div class="col-12 col-md-12">
                  <div class="row">
                    <div class="col-4 text-uppercase fw-bold text-sm mb-1">
                      <h4 class="fs-6 fw-bold">CUSTOMER GROWTH</h4>
                    </div>


                    <div class="col-3 p-0 m-0 text-uppercase fw-bold text-sm mb-1 row text-center">
                      <!-- <h4 class="fs-6 fw-bold"> M | F | G</h4> -->
                      <div class='col-4 p-0 m-0  border-end border-black'> 
                        M
                      </div>
                      <div class='col-4 p-0 m-0 border-start border-end border-black'> 
                        F
                      </div>
                      <div class='col-4 p-0 m-0 border-black border-start'>
                        G
                      </div>
                    </div>

                    <!-- Gender -->
                    <div class="col-5 ps-1 row text-uppercase fw-bold text-sm mb-1">
                      <div class="col-5 text-uppercase fw-bold text-sm mb-1">
                        Gender
                      </div>
                      <div class="col-7 p-0 m-0 text-uppercase fw-bold text-sm mb-1 row text-center">
                        <div class='col-6 p-0 m-0  border-end border-black'> 
                          A
                        </div>
                        <div class='col-6 p-0 m-0 border-black border-start'>
                          I
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Table-like structure -->
                <div class="col-12 text-xs" v-for="(growth,i) in customerGrowthData.data" :key="growth.period">
                  <!-- Today -->
                  <div class="row mb-1">
                    <div class="col-2 text-uppercase">{{ growth.period }}</div>
                    <div class="col-2">{{ growth.total }}
                    </div>
                    <div class="col-3 p-0 m-0 row text-center">
                      <div class='col-4 p-0 m-0  border-end border-black'> 
                        {{ growth.maleGrowth }}
                      </div>
                      <div class='col-4 p-0 m-0  border-end border-black'> 
                        {{ growth.femaleGrowth }}
                      </div>
                      <div class='col-4 p-0 m-0 '>
                        {{ growth.groupGrowth}}
                      </div>
                    </div>
                    <div class="row ps-1 col-5">
                      <div class="col-5 ">
                        {{growth.typeName}}
                      </div>
                      <div class="col-7 p-0 m-0 row text-center">
                        <div class='col-6 p-0 m-0  border-end border-black'>
                          {{growth.typeActive}}
                        </div>
                        <div class='col-6 p-0 m-0 '>
                          {{growth.typeInactive}}
                        </div>
                        <!-- <span v-if="i==0">{{ memberData?.active_male_count || 0 }} | {{ memberData?.inactive_male_count || 0 }} </span>
                        <span v-if="i==1">{{ memberData?.active_female_count || 0 }} | {{ memberData?.inactive_female_count || 0}} </span>
                        <span v-if="i==2">{{ memberData?.active_group_count || 0 }} | {{ memberData?.inactive_group_count || 0}} </span> -->
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Percentage -->
                <div class="col-2 text-xs text-uppercase">Percentage</div>
                <div class="col-10 text-xs">
                  <span :class="percentageClass(customerGrowthData?.percentage?.value)">
                    {{ customerGrowthData.percentage?.strvalue }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </b-skeleton-wrapper>
      </div>
      <!-- PENDING -->
      <div class="col-md-6 col-xl-6 mb-4">
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <b-card class="card-shape home-box">
              <b-skeleton width="85%" height="20%"></b-skeleton>
              <b-skeleton width="70%" height="20%"></b-skeleton>
              <b-skeleton width="70%" height="20%"></b-skeleton>
            </b-card>
          </template>
          <div class="card border-start-primary py-2 card-shape home-box" style="min-height: 163.58px !important;">
            <div class="card-body">
              <div class="row align-items-center no-gutters">
                <div class="col-12 col-md-12">
                  <div class="text-uppercase fw-bold text-sm mb-1">
                    <h4 class="fs-6 fw-bold">Pending</h4>
                  </div>
                </div>

                <div class="row align-items-center no-gutters">
                  <div class="col-md-5 col-5">
                    <div class="text-uppercase text-xs mb-1">
                      <span>Withdrawals</span>
                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="text-uppercase fw-bold text-xs mb-1">
                      <span>{{ today_pending_count }}</span>
                    </div>
                  </div>
                  <div class="col-md-4 col-4">
                    <div class="text-uppercase fw-bold text-xs mb-1">
                      <span>{{ displayNumber(today_pending) }}</span>
                    </div>
                  </div>
                  <div class="col-md-5 col-5">
                    <div class="text-uppercase text-xs mb-1">
                      <span>Journals</span>
                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="text-uppercase fw-bold text-xs mb-1">
                      <span>{{ allJournalsData.pending_journal_count }}</span>
                    </div>
                  </div>
                  <div class="col-md-4 col-4">
                    <div class="text-uppercase fw-bold text-xs mb-1">
                      <span>{{ displayNumber(allJournalsData.pending_journal_value) }}</span>
                    </div>
                  </div>

                  <div class="col-md-5 col-5">
                    <div class="text-uppercase text-xs mb-1">
                      <span>Vouchers</span>
                    </div>
                  </div>
                  <div class="col-md-3 col-3">
                    <div class="text-uppercase fw-bold text-xs mb-1">
                      <span>{{ allVoucherData.pending_voucher_count || 0 }}</span>
                    </div>
                  </div>
                  <div class="col-md-4 col-4">
                    <div class="text-uppercase fw-bold text-xs mb-1">
                      <span>{{ displayNumber(allVoucherData.pending_voucher_value) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-skeleton-wrapper>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-6 col-sm-6 col-12">
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <b-card class="card-shape home-box">
              <b-skeleton width="85%" height="20%"></b-skeleton>
              <b-skeleton width="70%" height="20%"></b-skeleton>
              <b-skeleton width="30%" height="20%"></b-skeleton>
              <b-skeleton width="50%" height="20%"></b-skeleton>
              <b-skeleton width="90%" height="20%"></b-skeleton>
            </b-card>
          </template>
          <div class="card mb-4 card-shape home-box">
            <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 class="m-0 fw-bold akkurate-dark">
                Transactions Chart
              </h6>
            </div>
            <b-card>
              <h3>{{ formatNumberWithInitials(transaction_total) }}</h3>
              <p class="akkurate-green">Last {{ numberOfPrvMonths }} Months {{ getPercentageChange(paymentsData[2].depositAmount + paymentsData[0].withdrawalAmount, transaction_total).strvalue }}</p>

              <div class="line chart">
                <PerformanceLineChart :lineChartData="combinedLineData" />
              </div>
            </b-card>
            <!-- <div class="card-body">
              <div>
              </div>
            </div> -->
          </div>
        </b-skeleton-wrapper>
      </div>

      <div class="col-xl-6 col-sm-6 col-12">
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <b-card class="card-shape home-box">
              <b-skeleton width="85%" height="20%"></b-skeleton>
              <b-skeleton width="70%" height="20%"></b-skeleton>
              <b-skeleton width="30%" height="20%"></b-skeleton>
              <b-skeleton width="50%" height="20%"></b-skeleton>
              <b-skeleton width="90%" height="20%"></b-skeleton>
            </b-card>
          </template>
          <div class="card mb-3 card-shape home-box">
            <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 class="m-0 fw-bold akkurate-dark">
                Loans by Category
              </h6>
            </div>
            <b-card>
              <h3>{{ formatNumberWithInitials(loan_product_total) }}</h3>
              <!-- <p class="akkurate-green">This Month +5%</p> -->
              <!-- draw a barchart and hard code a dummy data -->
              <div class="" style="">
                <bar-chart :chartLabel="'Loans by Category'" :labels="loan_product_labels" :data="loan_product_data" style="height: 385px;"></bar-chart>
              </div>
            </b-card>

          </div>
        </b-skeleton-wrapper>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-6 col-sm-6 col-12">
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <b-card class="card-shape home-box">
              <b-skeleton width="85%" height="20%"></b-skeleton>
              <b-skeleton width="70%" height="20%"></b-skeleton>
              <b-skeleton width="30%" height="20%"></b-skeleton>
              <b-skeleton width="50%" height="20%"></b-skeleton>
              <b-skeleton width="90%" height="20%"></b-skeleton>
            </b-card>
          </template>
          <div class="card mb-4 card-shape home-box" style="height: 385px;">
            <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 class="m-0 fw-bold akkurate-dark">
                Financial Performance Chart
              </h6>
            </div>
            <div class="card-body default-chart-size">
              <div>
                <PerformanceLineChart :lineChartData="lineChartData" />
              </div>
            </div>
          </div>
        </b-skeleton-wrapper>
      </div>
      <div class="col-xl-3 col-sm-6 col-12">
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <b-card class="card-shape home-box">
              <b-skeleton width="85%" height="20%"></b-skeleton>
              <b-skeleton width="70%" height="20%"></b-skeleton>
              <b-skeleton width="30%" height="20%"></b-skeleton>
              <b-skeleton width="50%" height="20%"></b-skeleton>
              <b-skeleton width="90%" height="20%"></b-skeleton>
            </b-card>
          </template>
          <div class="card mb-4 card-shape home-box" style="height: 385px;">
            <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 class="m-0 fw-bold akkurate-dark">Financial Position</h6>
            </div>
            <div class="card-body default-chart-size">
              <div class="pie-chart-area">
                <DoughnutChart :chartData="chartDataBalanceSheet" />
              </div>
              <hr />
              <div class="row">
                <div class="col akkurate-blue-text">
                  <div class="small">Assests</div>
                  <div class="akkurate-small">Today:{{ assest_today }}</div>
                  <div class="akkurate-small">Month:{{ assest_month }}</div>
                  <div class="akkurate-small">YTD:{{ assest_year }}</div>
                </div>
                <div class="col akkurate-green">
                  <div class="small">Liability & Capital</div>
                  <div class="akkurate-small">{{ lib_today }}</div>
                  <div class="akkurate-small">{{ lib_month }}</div>
                  <div class="akkurate-small">{{ liability_capital_year }}</div>
                </div>
              </div>
            </div>
          </div>
        </b-skeleton-wrapper>
      </div>
      <div class="col-xl-3 col-sm-6 col-12">
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <b-card class="card-shape home-box">
              <b-skeleton width="85%" height="20%"></b-skeleton>
              <b-skeleton width="70%" height="20%"></b-skeleton>
              <b-skeleton width="30%" height="20%"></b-skeleton>
              <b-skeleton width="50%" height="20%"></b-skeleton>
              <b-skeleton width="90%" height="20%"></b-skeleton>
            </b-card>
          </template>
          <div class="card mb-4 card-shape home-box">
            <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 class="m-0 fw-bold akkurate-dark">Income & Expenses</h6>
            </div>
            <div class="card-body default-chart-size">
              <div class="pie-chart-area">
                <DoughnutChart :chartData="chartDataIncome" />
              </div>
              <hr />
              <div class="row">
                <div class="col akkurate-danger">
                  <div class="small">Expenses</div>
                  <div class="akkurate-small">Today: {{ expenses_today }}</div>
                  <div class="akkurate-small">Month: {{ expenses_month }}</div>
                  <div class="text-xs">YTD:{{ expenses_year }}</div>
                </div>
                <div class="col akkurate-green">
                  <div class="small">Income</div>
                  <div class="akkurate-small"> {{ income_today }}</div>
                  <div class="akkurate-small">{{ income_month }}</div>
                  <div class="text-xs">{{ income_year }}</div>
                </div>
                <div class="col akkurate-blue-text">
                  <div class="small">P/L</div>
                  <div class="akkurate-small">{{ profit_loss_today }}</div>
                  <div class="akkurate-small">{{ profit_loss_month }}</div>
                  <div class="text-xs">{{ profit_loss_year }}</div>
                </div>
              </div>
            </div>
          </div>
        </b-skeleton-wrapper>
      </div>
      <div class="col-md-4 col-xl-4 mb-4">
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <b-card class="card-shape home-box">
              <b-skeleton width="85%" height="20%"></b-skeleton>
              <b-skeleton width="70%" height="20%"></b-skeleton>
              <b-skeleton width="70%" height="20%"></b-skeleton>
            </b-card>
          </template>
          <b-card class="card-height">
            <bar-chart :labels="labels" :data="data" />
          </b-card>
        </b-skeleton-wrapper>
      </div>
      <div class="col-md-4 col-xl-4 mb-4">
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <b-card class="card-shape home-box mb-4">
              <b-skeleton width="85%" height="20%"></b-skeleton>
              <b-skeleton width="70%" height="20%"></b-skeleton>
              <b-skeleton width="70%" height="20%"></b-skeleton>
            </b-card>
          </template>
          <b-card>
            <template #header>
              <div class="d-flex justify-content-between align-items-center my-1">
                <div class="fw-bold">Controls Statistic</div>
                <div class="text-end">
                  <a class="text-decoration-none small akkurate-green" href="#">see more
                    <i class="fas fa-arrow-right akkurate-extra-small"></i></a>
                </div>
              </div>
            </template>
            <!-- A custom formatted footer cell for field 'name' -->
            <template #footer>
              <div class="d-flex justify-content-between">
                <span class="small">Total</span>
                <span class="small">{{ Number(total_shares).toFixed(2) }}</span>
                <span class="small">{{ Number(total_savings).toFixed(2) }}</span>
              </div>

            </template>
            <b-table class="small session-table-height" :fields="member_total_fields" :items="member_total_items" hover striped responsive small></b-table>

            <hr class="my-2" />
            <div class="small fw-bold mb-1">Number of Youth Savers (if applicable)</div>
            <b-table-simple bordered small responsive>
              <b-thead>
                <b-tr variant="secondary">
                  <b-th>Total</b-th>
                  <b-th>Females</b-th>
                  <b-th>Males</b-th>
                  <b-th>Groups</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr>
                  <b-td>{{ youthSavers.total }}</b-td>
                  <b-td>{{ youthSavers.females }}</b-td>
                  <b-td>{{ youthSavers.males }}</b-td>
                  <b-td>{{ youthSavers.groups }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-card>
        </b-skeleton-wrapper>
      </div>
      <div class="col-md-4 col-xl-4 mb-4">
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <b-card class="card-shape home-box mb-4">
              <b-skeleton width="85%" height="20%"></b-skeleton>
              <b-skeleton width="70%" height="20%"></b-skeleton>
              <b-skeleton width="70%" height="20%"></b-skeleton>
            </b-card>
          </template>
          <div class="card mb-4 card-shape home-box">
            <div class="card-header py-3">
              <div class="row">
                <div class="col-6">
                  <h6 class="m-0 fw-bold akkurate-dark">Collection Tracker</h6>
                </div>
              </div>
              <div>
              </div>
            </div>
            <div class="card-body session-table-height">
              <b-table class="small" :fields="collect_fields" :items="collect_items" striped responsive :per-page="perPage" :current-page="currentPage" small>
              </b-table>
            </div>
            <div class="card-footer">
              <b-pagination class="text-end" v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="daily-control-tb" align="right">
              </b-pagination>
            </div>
          </div>
        </b-skeleton-wrapper>
      </div>
      <div class="col-md-12 col-xl-12">
        <div class="card mb-4 card-shape home-box">
          <div class="card-header py-3">
            <div class="row">
              <div class="col-12">
                <h6 class="m-0 fw-bold akkurate-dark">Financial Highlight</h6>
              </div>
            </div>
          </div>
          <div class="card-body">
            <b-table class="small" :fields="fields" :items="items" striped responsive small>
              <template #thead-top>
                <b-tr>
                  <b-th width="40%"><span>{{ assets }}</span></b-th>
                  <b-th></b-th>
                  <b-th></b-th>
                  <b-th></b-th>
                  <b-th></b-th>
                </b-tr>
              </template>
              <template #custom-foot>
                <b-tr>
                  <b-th>TOTAL</b-th>
                  <b-th>{{ getActualAmount }}</b-th>
                  <b-th>100%</b-th>
                  <b-th>{{ getStandardAmount }}</b-th>
                  <b-th>100%</b-th>
                </b-tr>
              </template>
            </b-table>
          </div>
          <div class="card-body">
            <b-table class="small" :fields="fields" :items="lib_items" striped responsive small>
              <template #thead-top>
                <b-tr>
                  <b-th width="40%"><span>{{ liability }}</span></b-th>
                  <b-th></b-th>
                  <b-th></b-th>
                  <b-th></b-th>
                  <b-th></b-th>
                </b-tr>
              </template>
              <template #custom-foot>
                <b-tr>
                  <b-th>TOTAL</b-th>
                  <b-th>{{ getActualAmountLib }}</b-th>
                  <b-th>100%</b-th>
                  <b-th>{{ getStandardAmountLib }}</b-th>
                  <b-th>100%</b-th>
                </b-tr>
              </template>
            </b-table>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>
<script>
import DoughnutChart from "../Charts/DoughnutChart.vue";
import ApiService from "@/core/services/api.service";
import PerformanceLineChart from "../Charts/PerformanceLineChart.vue";
import BarChart from "../Charts/BarChart.vue";
import LineChart from "../Charts/LineChart.vue";
import Institution from "../institution/Institution.vue";
export default {
  data() {
    return {
      customerGrowthData: {
        percentage: {
          value: 0,
          strvalue: `0.00 %`
        },
        data: [
          { period: "Today", total: 0 , maleGrowth: 0, femaleGrowth: 0, groupGrowth: 0, typeName: 'MALE', typeActive: 0, typeInactive: 0},
          { period: "Month", total: 0 , maleGrowth: 0, femaleGrowth: 0, groupGrowth: 0, typeName: 'FEMALE', typeActive: 0, typeInactive: 0 },
          { period: "Annual", total: 0 , maleGrowth: 0, femaleGrowth: 0, groupGrowth: 0, typeName: 'GROUP', typeActive: 0, typeInactive: 0 },
        ]
      },
      loanData: [
        {
          period: "Today",
          repayment: { count: 0, amount: 0 },
          principalInterest: {
            p: 0, i: 0, percentage: {
              value: 0,
              strvalue: '0.00 %'
          } },
          disbursement: { count: 0, amount: 0 },
          variance: 0,
          showChange: true,
        },
        {
          period: "Month",
          repayment: { count: 0, amount: 0 },
          principalInterest: {
            p: 0, i: 0, percentage: {
              value: 0,
              strvalue: '0.00 %'
            }
          },
          disbursement: { count: 0, amount: 0 },
          variance: 0,
          showChange: true,
        },
        {
          period: "Annual",
          repayment: { count: 0, amount: 0 },
          principalInterest: {
            p: 0, i: 0, percentage: {
              value: 0,
              strvalue: '0.00 %'
          } },
          disbursement: { count: 0, amount: 0 },
          variance: 0,
          showChange: false,
        }
      ],
      today_deposit: 0,
      monthly_deposit: 0,
      yearly_deposit: 0,
      today_withdrawal: 0,
      monthly_withdrawal: 0,
      yearly_withdrawal: 0,
      today_balance: 0,
      monthly_balance: 0,
      yearly_balance: 0,
      today_pending_count: 0,
      today_pending: 0,
      monthly_pending_count: 0,
      monthly_pending: 0,
      yearly_pending_count: 0,
      yearly_pending: 0,
      balance_sheet_name: [],
      balance_sheet_value: [],
      color_value: [],
      paymentsData: [
        {
          key: "daily",
          label: "Today",
          depositCount: 0,
          depositAmount: 0,
          withdrawalCount: 0,
          withdrawalAmount: 0,
          showChange: true,
          balance: 0,
          percentageChange: {
            value: 0,
            strvalue: `${Math.abs(0).toFixed(2)} %`
          },
        },
        {
          key: "monthly",
          label: "Month",
          depositCount: 0,
          depositAmount: 0,
          withdrawalCount: 0,
          withdrawalAmount: 0,
          showChange: true,
          balance: 0,
          percentageChange: {
            value: 0,
            strvalue: `${Math.abs(0).toFixed(2)} %`
          },
        },
        {
          key: "yearly",
          label: "Annual",
          depositCount: 0,
          depositAmount: 0,
          withdrawalCount: 0,
          withdrawalAmount: 0,
          showChange: false, // yearly vs yearly doesn’t need % change
          balance: 0,
          percentageChange: {
            value: 0,
            strvalue: `${Math.abs(0).toFixed(2)} %`
          },
        },
      ],
      chartDataBalanceSheet: {
        labels: [],
        datasets: [],
      },
      chartDataIncome: {
        labels: [],
        datasets: [],
      },
      lineChartData: {
        labels: [],
        datasets: [],
      },
      combinedLineData: {
        labels: [],
        datasets: []
      },
      transaction_total: 0,
      // loanBarData: {
      //   labels: ['Personal', 'Business', 'Mortgage', 'Auto', 'Other'],
      //   datasets: [{
      //     label: 'Loans',
      //     data: [0, 0, 0, 0, 0],
      //     backgroundColor: '#4A90E2',
      //     borderRadius: 4,
      //     barPercentage: 0.5
      //   }]
      // },

      loan_product_labels: [],
      loan_product_data: [],
      loan_product_total: 0,
      numberOfPrvMonths: 0
      // datasets: [
      //     {
      //       label: 'Deposits',
      //       data: [],
      //       fill: false,
      //       borderColor: '#198754',
      //       backgroundColor: '#198754',
      //     },
      //   ]
      ,

      loading: false,
      labels: [],
      data: [],
      member_total_items: [],
      member_total_fields: [
        {
          key: "state",
          label: "Total members"
        },

        {
          key: "shares",
          label: "Shares"
        },
        {
          key: "savings",
          label: "All Savings"
        }
      ],
      total_shares: 0,
      total_savings: 0,
      items: [],
      lib_items: [],
      fields: [
        {
          key: "display_name",
          label: "Particulars",
        },
        {
          key: "actual",
          label: "Actual Amount",
        },
        {
          key: "actual_percent",
          label: "%",
        },
        {
          key: "standard_amount",
          label: "Standard Amount",
        },

        {
          key: "standard_percent",
          label: "%",
        },
      ],
      assets: "",
      liability: "",
      collect_fields: [
        {
          key: "name",
          label: "Name",
        },
        {
          key: "today_balance",
          label: "Today",
        },
        {
          key: "ytd_balance",
          label: "YTD",
        },
      ],
      collect_items: [],
      perPage: 5,
      currentPage: 1,
      assest_year: 0,
      assest_today: 0,
      lib_year: 0,
      liability_capital_year: 0,
      expenses_year: 0,
      income_year: 0,
      profit_loss_year: 0,
      lib_today: 0,
      capital_today: 0,
      liability_capital_today: 0,
      income_today: 0,
      expenses_today: 0,
      profit_loss_today: 0,
      assest_month: 0,
      lib_month: 0,
      liability_capital_month: 0,
      income_month: 0,
      expenses_month: 0,
      profit_loss_month: 0,
      // Hello
      memberData: {},
      youthSavers: {
        total: 0,
        females: 0,
        males: 0,
        groups: 0,
      },
      allLoansData: {},
      allJournalsData: {},
      allVoucherData: {},
      loadingFd: false,
      fdFilterValue:{name: 'All'},
      fdScheme: [],
      mainFdData: [],
      fixedTermDepositData: {
        type: "ALL",
        data: [
        {
          label: "PENDING",
          count: 0,
          principal: 0,
          interest: 0,
          value: 0,
        },
        {
          label: "RUNNING",
          count: 0,
          principal: 0,
          interest: 0,
          value: 0,
        },
        {
          label: "REDEEMED",
          count: 0,
          principal: 0,
          interest: 0,
          value: 0,
        },
        {
          label: "CANCELLED",
          count: 0,
          principal: 0,
          interest: 0,
          value: 0,
        }
      ]
      }
    };
  },
  components: {
    DoughnutChart,
    PerformanceLineChart,
    BarChart,
    LineChart,
  },
  created() {
    // Call your API here
    this.getFdDropdown();
    this.getGenMangDashboardApi();
    this.getInfo();
  },
  methods: {
    variance(repayments, disbursement) {
      // Calculate variance logic here
      return disbursement - repayments;
    },
    percentageClass(value) {
      if (value < 0) return "akkurate-danger";
      if (value > 0) return "akkurate-green";
      return "akkurate-gray";
    },
    getLoanInfo(res) {
      let total = 0;
      // Loan Tablet Data
      this.loanData[0].repayment.amount = res.repayment.total_amount;
      this.loanData[1].repayment.amount = res.repayment.monthly_amount;
      this.loanData[2].repayment.amount = res.repayment.yearly_amount;

      this.loanData[0].repayment.count = res.repayment.total_count;
      this.loanData[1].repayment.count = res.repayment.monthly_count;
      this.loanData[2].repayment.count = res.repayment.yearly_count;

      // Setting of P | I variables
      this.loanData[0].principalInterest.p = res.principal.total_amount
      this.loanData[0].principalInterest.i = res.interest.total_amount
      total = this.loanData[0].principalInterest.p + this.loanData[0].principalInterest.i
      // this.loanData[0].principalInterest.percentage = this.getPercentageChange(total, total - 20)
      this.loanData[0].principalInterest.percentage = {
        value: 0,
        strvalue: `${Math.abs(0).toFixed(2)} %`
      }

      this.loanData[1].principalInterest.p = res.principal.monthly_amount
      this.loanData[1].principalInterest.i = res.interest.monthly_amount
      total = this.loanData[1].principalInterest.p + this.loanData[1].principalInterest.i
      // this.loanData[1].principalInterest.percentage = this.getPercentageChange(total, total - 20)
      this.loanData[1].principalInterest.percentage = {
        value: 0,
        strvalue: `${Math.abs(0).toFixed(2)} %`
      }

      this.loanData[2].principalInterest.p = res.principal.yearly_amount
      this.loanData[2].principalInterest.i = res.interest.yearly_amount
      total = this.loanData[2].principalInterest.p + this.loanData[2].principalInterest.i

      // Setting of Repayment
      this.loanData[0].disbursement.amount = res.disbursement.total_amount;
      this.loanData[1].disbursement.amount = res.disbursement.monthly_amount;
      this.loanData[2].disbursement.amount = res.disbursement.yearly_amount;

      this.loanData[0].disbursement.count = res.disbursement.total_count;
      this.loanData[1].disbursement.count = res.disbursement.monthly_count;
      this.loanData[2].disbursement.count = res.disbursement.yearly_count;
    },
    getDepositOverTimeInfo(res) {
      this.transaction_total = 0;
      let dArray = [];
      res?.deposit_over_time?.forEach((data, i) => {
        dArray[i] = data.amount
        this.transaction_total += data.amount

      })
      this.numberOfPrvMonths = res?.deposit_over_time.length - 1

      let wArray = [];
      res?.withdrawal_over_time?.forEach((data, i) => {
        wArray[i] = data.amount
        this.transaction_total += data.amount
      })

      // Combined chart with both datasets
      const labels = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];


      this.combinedLineData = {
        labels: labels,
        datasets: [
          {
            label: 'Deposits',
            data: [...dArray],
            fill: false,
            borderColor: '#198754',
            backgroundColor: '#198754',
          },
          {
            label: 'Withdrawals',
            data: [...wArray],
            fill: false,
            borderColor: '#E74C3C',
            backgroundColor: '#E74C3C',
          }
          //   {
          //     label: 'Data One',
          //     backgroundColor: '#f87979',
          //     data: [40, 39, 10, 40, 39, 80, 40]
          //   }
          // ,
          // {
          //     label: 'Data One',
          //     backgroundColor: '#f87979',
          //     data: [60, 38, 20, 90, 30, 65, 47]
          //   }
        ]
      }
      // console.log("Deposit Over Time Data: ", this.combinedLineData);
    },
    getPaymentsInfo(res) {
      // Daily
      this.paymentsData[0].depositAmount = res.deposit.total_amount
      this.paymentsData[0].depositCount = res.deposit.total_count
      this.paymentsData[0].withdrawalAmount = res.withdrawal.total_amount
      // this.paymentsData[0].percentageChange = this.getPercentageChange(this.paymentsData[0].depositAmount, this.paymentsData[0]?.depositAmount - 2)
      this.paymentsData[0].percentageChange = {
        value: 0,
        strvalue: `${Math.abs(0).toFixed(2)} %`
      }


      this.paymentsData[0].balance = res.balance.total_amount
      // Monthly
      this.paymentsData[1].depositAmount = res.deposit.monthly_amount
      this.paymentsData[1].depositCount = res.deposit.monthly_count
      this.paymentsData[1].withdrawalAmount = res.withdrawal.monthly_amount
      // this.paymentsData[1].percentageChange = this.getPercentageChange(this.paymentsData[1].depositAmount, this.paymentsData[1].depositAmount - 2)
      this.paymentsData[1].percentageChange = {
        value: 0,
        strvalue: `${Math.abs(0).toFixed(2)} %`
      }


      this.paymentsData[1].balance = res.balance.monthly_amount
      // Yearly
      this.paymentsData[2].depositAmount = res.deposit.yearly_amount
      this.paymentsData[2].depositCount = res.deposit.yearly_count
      this.paymentsData[2].withdrawalAmount = res.withdrawal.yearly_amount
      this.paymentsData[2].withdrawalCount = res.withdrawal.yearly_count
      this.paymentsData[2].balance = res.balance.yearly_amount
    },
    getInfo() {
      ApiService.get("status-summary").then(response => {
        this.memberData = response.data.customers
        const ys = response.data?.youth_savers || {};
        this.youthSavers = {
          total: Number(ys.total) || 0,
          females: Number(ys.females) || 0,
          males: Number(ys.males) || 0,
          groups: Number(ys.groups) || 0,
        };
        this.allLoansData = response.data.loans
        this.allJournalsData = response.data.journals
        this.allVoucherData = response.data.vouchers
        this.mainFdData = response.data.fixed_deposit;
        this.fixedTermDepositData.data = this.mainFdData;

        console.log("FIXED DEPOSIT Data: ", this.fixedTermDepositData.data);
        console.log("Member Data: ", this.memberData);
        // Today info
        this.customerGrowthData.data[0].total = this.memberData.today_customer_count;  
        this.customerGrowthData.data[0].maleGrowth = this.memberData.today_male_count;
        this.customerGrowthData.data[0].femaleGrowth = this.memberData.today_female_count;
        this.customerGrowthData.data[0].groupGrowth = this.memberData.today_group_count;

        // SETTING 
        this.customerGrowthData.data[0].typeActive = this.memberData?.active_male_count;
        this.customerGrowthData.data[0].typeInactive = this.memberData?.inactive_male_count;

        // Monthly info
        this.customerGrowthData.data[1].total = this.memberData.month_customer_count;
        this.customerGrowthData.data[1].femaleGrowth = this.memberData.month_female_count;
        this.customerGrowthData.data[1].maleGrowth = this.memberData.month_male_count;
        this.customerGrowthData.data[1].groupGrowth = this.memberData.month_group_count;
        
        // SETTING 
        this.customerGrowthData.data[0].typeActive = this.memberData?.active_female_count;
        this.customerGrowthData.data[0].typeInactive = this.memberData?.inactive_female_count;

        // Yearly info
        this.customerGrowthData.data[2].total = this.memberData.year_customer_count;
        this.customerGrowthData.data[2].femaleGrowth = this.memberData.female;
        this.customerGrowthData.data[2].maleGrowth = this.memberData.male;
        this.customerGrowthData.data[2].groupGrowth = this.memberData.group;

        // SETTING 
        this.customerGrowthData.data[0].typeActive = this.memberData?.active_group_count;
        this.customerGrowthData.data[0].typeInactive = this.memberData?.inactive_group_count;

        this.customerGrowthData.percentage = this.getPercentageChange(this.customerGrowthData.data[2].total,
          Number(this.customerGrowthData.data[2].total) + Number(this.memberData.current_year_customer_count));

        console.log(this.customerGrowthData.percentage)

      }).catch((err) => {
        console.log(err)
        return [];  // Return an empty array in case of error to prevent the table from breaking
      });
    },

    getLoanCategory(res) {
      res?.loan_products?.forEach((data, i) => {
        this.loan_product_labels[i] = data.loan_product_name
      })

      this.loan_product_total = 0
      res?.loan_products?.forEach((data, i) => {
        this.loan_product_data[i] = data.total_amount
        this.loan_product_total += data.total_amount
      })


      console.log("Product Labels: ", this.loan_product_labels);
      console.log("Total Amount: ", this.loan_product_data);
      // this.loan_product = {
      //   labels: [...product_name],
      //   datasets: [
      //     {
      //       label: 'Deposits',
      //       data: [...total_amount],
      //       fill: false,
      //       borderColor: '#198754',
      //       backgroundColor: '#198754',
      //     },
      //   ]
      // }

      // console.log(this.loan_product);


      Number(this.loan_product_total).toFixed(2)

    },
    async getGenMangDashboardApi() {
      // Your API call logic goes here
      // console.log("GEN Man API called!");
      this.loading = true;
      await ApiService.query("/dashboard/general-manager")
        .then((response) => {
          const res = response.data;
          console.log("Dashboard Data: ", res);
          this.today_deposit = res?.deposit?.total_amount;
          this.monthly_deposit = res?.deposit?.monthly_amount;
          this.yearly_deposit = res?.deposit?.yearly_amount;
          this.today_withdrawal = res?.withdrawal?.total_amount;
          this.monthly_withdrawal = res?.withdrawal?.monthly_amount;
          this.yearly_withdrawal = res?.withdrawal?.yearly_amount;
          this.today_balance = res?.balance?.total_amount;
          this.monthly_balance = res?.balance?.monthly_amount;
          this.yearly_balance = res?.balance?.yearly_amount;
          this.today_pending_count = res?.pending?.total_count;
          this.today_pending = res?.pending.total_amount;
          this.monthly_pending_count = res.pending?.monthly_count;
          this.monthly_pending = res?.pending?.monthly_amount;
          this.yearly_pending_count = res.pending?.yearly_count;
          this.yearly_pending = res?.pending?.yearly_amount;
          this.loading = false;

          var balance_sheet_name = []
          var balance_sheet_value = []

          var profit_loss_name = []
          var profit_loss_value = []


          this.getLoanInfo(res);
          this.getDepositOverTimeInfo(res)
          this.getPaymentsInfo(res);
          this.getLoanCategory(res);

          // console.log(res.loan_products.map(index => index?.loan_product_name ?? []));
          // console.log(res.loan_products.map(index => index?.total_amount ?? []));

          // this.loan_product = {
          //   labels: res.loan_products.map(index => index?.loan_product_name ?? []),
          //   datasets: [{
          //     label: 'Loans',
          //     data: res.loan_products.map(index => index?.total_amount ?? []),
          //     backgroundColor: '#4A90E2',
          //     borderRadius: 4,
          //     barPercentage: 0.5
          //   }]
          // }

          // Populate the arrays
          for (const [key, value] of Object.entries(res?.ps.balance_sheet_year)) {
            balance_sheet_name.push(key);
            balance_sheet_value.push(value);
          }

          // Populate the arrays
          for (const [key, value] of Object.entries(res?.ps.profit_loss_year)) {
            profit_loss_name.push(key);
            profit_loss_value.push(value);
          }

          this.chartDataBalanceSheet = {
            labels: balance_sheet_name,
            datasets: [
              {
                backgroundColor: ["#3681c2", "#018673", "#00D8FF",],
                data: balance_sheet_value,
              },
            ],
          };
          this.chartDataIncome = {
            labels: profit_loss_name,
            datasets: [
              {
                backgroundColor: ["#018673", "#E46651", "#3681c2",],
                data: profit_loss_value,
              },
            ],
          };
          //Year to Date
          this.assest_year = res.ps?.balance_sheet_year.total_assets
          this.lib_year = res.ps?.balance_sheet_year.total_liabilities;
          this.capital_year = res.ps?.balance_sheet_year.total_capital
          this.liability_capital_year = this.lib_year + this.capital_year;

          this.income_year = res.ps?.profit_loss_year.total_income;
          this.expenses_year = res.ps?.profit_loss_year.total_expenses;
          this.profit_loss_year = res.ps?.profit_loss_year.profit_and_loss;

          //Today
          this.assest_today = res.ps?.balance_sheet_today.total_assets;
          this.lib_today = res.ps?.balance_sheet_today.total_liabilities;
          this.capital_today = res.ps?.balance_sheet_today.total_capital;
          this.liability_capital_today = this.lib_today + this.capital_today;

          this.income_today = res.ps?.profit_loss_today.total_income;
          this.expenses_today = res.ps?.profit_loss_today.total_expenses;
          this.profit_loss_today = res.ps?.profit_loss_today.profit_and_loss;

          //Month
          this.assest_month = res.ps?.balance_sheet_month.total_assets;
          this.lib_month = res.ps?.balance_sheet_month.total_liabilities;
          this.capital_month = res.ps?.balance_sheet_month.total_capital;
          this.liability_capital_month = this.lib_month + this.capital_month;

          this.income_month = res.ps?.profit_loss_month.total_income;
          this.expenses_month = res.ps?.profit_loss_month.total_expenses;
          this.profit_loss_month = res.ps?.profit_loss_month.profit_and_loss;


          var duration = res.performance_chart.total_assest.weeks;
          var total_perform_assest_value = res.performance_chart.total_assest.weeklySums;
          var total_perform_liability_value = res.performance_chart.total_liability.weeklySums;
          var total_perform_capital_value = res.performance_chart.total_capital.weeklySums;
          var total_perform_income_value = res.performance_chart.total_income.weeklySums;
          var total_perform_expenses_value = res.performance_chart.total_expenses.weeklySums;
          var total_perform_surplus_value = res.performance_chart.total_surplus.weeklySums;
          this.lineChartData = {
            labels: duration,
            datasets: [
              {
                label: "Assest",
                data: total_perform_assest_value,
                fill: false,
                borderColor: "#01a790",
                backgroundColor: "#01a790",
                borderWidth: 2,
              },
              {
                label: "Liability",
                data: total_perform_liability_value,
                fill: false,
                borderColor: "#E46651",
                backgroundColor: "#E46651",
                borderWidth: 2,
              },
              {
                label: "Capital",
                data: total_perform_capital_value,
                fill: false,
                borderColor: "#DD1B16",
                backgroundColor: "#DD1B16",
                borderWidth: 2,
              },
              {
                label: "Income",
                data: total_perform_income_value,
                fill: false,
                borderColor: "#FF69B4",
                backgroundColor: "#FF69B4",
                borderWidth: 2,
              },
              {
                label: "Expenses",
                data: total_perform_expenses_value,
                fill: false,
                borderColor: "#41B883",
                backgroundColor: "#41B883",
                borderWidth: 2,
              },
              {
                label: "Surplus",
                data: total_perform_surplus_value,
                fill: false,
                borderColor: "#FF4500",
                backgroundColor: "#FF4500",
                borderWidth: 2,
              },
            ],
          };
          this.labels = response.data.branches.branch_names;
          this.data = response.data.branches.branch_total;
          this.member_total_items = response.data.member_stat.control_summary;
          this.items = res.financial_highlight.assets;
          this.lib_items = res.financial_highlight.liabilities;
          this.assets = 'ASSET';
          this.liability = ' LIABILITY/EQUITY';
          this.collect_items = response.data.collection_tracker;
          this.total_shares = response.data.member_stat.total_shares;
          this.total_savings = response.data.member_stat.total_savings;
          // console.log(response)


        })
        .catch(function (error) {
          // this.isLoading = false;
          // return error;
          console.log(error);
        });
    },
    getPercentageChange(previousAmount, currentAmount) {
      if (previousAmount === 0) {
        return {
          value: 0,
          strvalue: `${Math.abs(0).toFixed(2)} %`
        }

      }

      const big = currentAmount > previousAmount ? currentAmount : previousAmount
      const difference = currentAmount - previousAmount;
      const percentage = (difference / big) * 100;

      if (percentage < 0) {
        return {
          value: Math.abs(percentage).toFixed(2),
          strvalue: `-${Math.abs(percentage).toFixed(2)} %`
        };
      } else if (percentage > 0) {
        return {
          value: percentage.toFixed(2),
          strvalue: `+${percentage.toFixed(2)} %`
        };
      }

      return {
        value: percentage.toFixed(2),
        strvalue: `${percentage.toFixed(2)} %`
      };
    },
    Filter(filterValue) {
      this.loadingFd = true;
      this.fdFilterValue = filterValue;

      this.fixedTermDepositData.type = filterValue.name;

      console.log("Selected Filter: ", this.fdFilterValue);
      if (this.fixedTermDepositData.type.toLowerCase() === "all") {
        this.fixedTermDepositData.data = this.mainFdData;

        this.loadingFd = false;
      } else {
        this.getSpecificFdInfo(this.fdFilterValue.id);
      }
      // this.getFdDropdown();
    },
    async getFdDropdown() {
			await ApiService.get(
				"/investments/fixed-term-deposits/dropdown"
			)
				.then((response) => {
					// this.branches = response.data.branches;
					// this.liquid_funds = response.data.liquid_funds;
					this.fdScheme = response.data.fd_scheme;
					// this.bank_currents = response.data.bank_currents;

					// this.product_options = response.data.coa_subheads;
					console.log("Dropdown",this.fdScheme);
				})
				.catch((error) => {
					console.log(error);
				});
    },
    async getSpecificFdInfo(id) {

      await ApiService.get(
        "/status-summary/fd_filter/"+id)
        .then((response) => {
          // this.branches = response.data.branches;
          // this.liquid_funds = response.data.liquid_funds;
          this.fixedTermDepositData.data = response.data.fixed_deposit;
          // this.bank_currents = response.data.bank_currents;

          // this.product_options = response.data.coa_subheads;
          console.log(this.fixedTermDepositData.data);
        })
        .catch((error) => {
          console.log(error);
        }).finally(() => {
          this.loadingFd = false;
        });
    }
  },
  computed: {
    rows() {
      return this.collect_items.length;
    },
    getActualAmount() {
      let sum = 0;
      this.items.forEach((index) => {
        sum += Number(index.actual);
      });
      return sum.toFixed(2);
    },
    getActualAmountLib() {
      let sum = 0;
      this.lib_items.forEach((index) => {
        sum += Number(index.actual);
      });
      return sum.toFixed(2);
    },
    getStandardAmount() {
      let sum = 0;
      this.items.forEach((index) => {
        sum += Number(index.standard_amount);
      });
      return sum.toFixed(2);
    },
    getStandardAmountLib() {
      let sum = 0;
      this.lib_items.forEach((index) => {
        sum += Number(index.standard_amount);
      });
      return sum.toFixed(2);
    },
    getDaillyDepositDiff() {
      let total = this.today_deposit - (this.previous_day || 0)
      return total
    },
    getMonthlyDepositDiff() {
      let total = this.monthly_deposit - (this.previous_month || 0)
      return total
    },
    getYearlyDepositDiff() {
      let total = this.yearly_deposit - (this.previous_year || 0)
      return total
    },
    getDaillyLoanDiff() {
      let total = this.today_deposit - (this.previous_day || 0)
      return total
    },
    getMonthlyLoanDiff() {
      let total = this.monthly_deposit - (this.previous_month || 0)
      return total
    },
    getYearlyLoanDiff() {
      let total = this.yearly_deposit - (this.previous_year || 0)
      return total
    }
  },
};
</script>
<style scoped>
.session-table-height {
  height: 230px;
}

.card-height {
  height: 350px;
}


.text-blue {
  color: #0165d1;
}

.vertical-divider {
  width: 2px;
  height: 16px;
  background-color: #000;
  border-radius: 10px;
  margin: 0 4px;
  opacity: 0.6;
}

/* #lineChart {} */
</style>